// frontend/src/components/Layout/Layout.jsx

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { menuAPI } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../context/TranslationContext';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const { isAuthenticated } = useAuth();
  const { currentLanguage } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) loadMenu();
  }, [isAuthenticated, currentLanguage]);

  const loadMenu = async () => {
    try {
      const response = await menuAPI.getAll(currentLanguage);
      if (response.data.success) setMenuItems(response.data.menu);
    } catch (err) {
      console.error('Layout: failed to load menu', err);
    }
  };

  // Build breadcrumb trail by walking the menu tree for the current path
  const buildBreadcrumb = (items, pathname, trail = []) => {
    for (const item of items) {
      const current = [...trail, item];
      if (item.path && (pathname === item.path || pathname.startsWith(item.path + '/'))) {
        return current;
      }
      if (item.children?.length) {
        const found = buildBreadcrumb(item.children, pathname, current);
        if (found) return found;
      }
    }
    return null;
  };

  const breadcrumb = buildBreadcrumb(menuItems, location.pathname) || [];

  return (
    <div className="app-layout">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(c => !c)}
        menuItems={menuItems}
        onMenuLoaded={setMenuItems}
      />
      <div className={`layout-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header
          onToggleSidebar={() => setSidebarCollapsed(c => !c)}
          sidebarCollapsed={sidebarCollapsed}
          breadcrumb={breadcrumb}
        />
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;